import React from 'react';

const ArrowTop = () => {
	return (
		<svg
			viewBox="0 0 32 32"
			width="32"
			height="32"
			fill="none"
			stroke="currentcolor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="3"
		>
			<path d="M6 10 L16 2 26 10 M16 2 L16 30" />
		</svg>
	);
};

export default ArrowTop;



// WEBPACK FOOTER //
// ./src/components/icons/ArrowTop.js